import { ChangeEvent, useContext, useEffect, useState } from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import UIService from "../../../services/UIService";
import OwButton from "../../shared/OwButton/OwButton";
import Typeahead from "../../shared/Typeahead/Typeahead";
import ICatalog_Item from "../../../models/ICatalog_Item";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import ICatalog from "../../../models/ICatalog";
import IPrice_Group from "../../../models/IPrice_Group";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import VendorContext from "../../../contexts/VendorContext";
import INotification from "../../../models/INotification";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import * as _ from "lodash-es";
import IDashboardEntryItemUI from "../../../models/IDashboardEntryItemUI";
import { DashboardItemEntryQty } from "./DashboardItemEntryQty/DashboardItemEntryQty";
import { DashboardItemEntryPricePerUnit } from "./DashboardItemEntryPricePerUnit/DashboardItemEntryPricePerUnit";
import { NumericFormat } from "react-number-format";
import IReconcileOrderWithItemsResultsDTO from "../../../models/DTO/IReconcileOrderWithItemsResultsDTO";
import IDashboardEntryConfig from "../../../models/IDashboardEntryConfig";
import DashboardEntryRenderFnEnum from "../../../models/DashboardEntryRenderFnEnum";
import IDashboardEntryCol from "../../../models/IDashboardEntryCol";
import UiContext from "../../../contexts/UiContext";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import SupplierGuidEnum from "../../../models/SupplierGuidEnum";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { SocketContext } from "@contexts/SocketContext";
import "./DashboardItemEntryPanel.scss";
import { startCase } from "lodash-es";
import { OrderItemOptions } from "@components/shared/OrderItemOptions/OrderItemOptions";
import INewOrder_Item_Option from "@models/INewOrder_Item_Option";
import IOrder_Item_Option from "@models/IOrder_Item_Option";
import OrderEntryService from "../../../services/OrderEntryService";
import CatalogItemService from "../../../services/CatalogItemService";

type Props = {
    catalog: ICatalog;
    priceGroup: IPrice_Group;
    dashboardEntryItems: IDashboardEntryItemUI[];
    addItem: (item: IDashboardEntryItemUI) => void;
    removeItem: (item: IDashboardEntryItemUI) => void;
    updateItem: (item: IDashboardEntryItemUI) => void;
    getPricingValue: (item: ICatalog_Item) => number;
    submitErrors?: IReconcileOrderWithItemsResultsDTO;
};

export const DashboardItemEntryPanel = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const vendorModel = useContext(VendorContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const isMainViewLight = UIService.isMainViewLight();

    const addItem = () => {
        if (selectedCatalogItem && requiredItemOptionsComplete) {
            console.log("manualPrice: ", manualPrice, pricePerUnit);
            const price = manualPrice ? pricePerUnit : props.getPricingValue(selectedCatalogItem);

            const item: IDashboardEntryItemUI = {
                qty: Number(qty),
                Catalog_Item: selectedCatalogItem,
                description,
            };

            if (selectedItemOptions.length > 0) {
                item.Item_Options = selectedItemOptions;
            }

            if (price !== Number(pricePerUnit)) {
                item.manual_price = Number(pricePerUnit);
            }

            if (manualPrice) {
                item.manual_price = Number(pricePerUnit || 0);
            }

            if (msrp !== 0) {
                item.msrp = Number(msrp);
            }

            console.log("addItem: ", item);

            props.addItem(item);

            setQty(1);
            setSelectedCatalogItem(undefined);
            setPricePerUnit("");
            setDescription("");
            setClearTypeahead(true);
            setSelectedItemOptions([]);
        }
    };

    const defaultConfig = (): IDashboardEntryConfig => {
        return {
            widgets: [],
            columns: [
                {
                    title: "no",
                    topRowColFn: DashboardEntryRenderFnEnum.ADD_BTN,
                    renderFn: DashboardEntryRenderFnEnum.ITEM_NO,
                },
                {
                    title: "item",
                    topRowColFn: DashboardEntryRenderFnEnum.ITEM_LOOKUP,
                    renderFn: DashboardEntryRenderFnEnum.SKU,
                },
                {
                    title: "description",
                    topRowColFn: DashboardEntryRenderFnEnum.DESCRIPTION,
                    renderFn: DashboardEntryRenderFnEnum.DESCRIPTION,
                },
                {
                    title: "qty",
                    topRowColFn: DashboardEntryRenderFnEnum.QTY,
                    renderFn: DashboardEntryRenderFnEnum.QTY,
                    allowEdit: true,
                },
                {
                    title: "price_per_unit",
                    topRowColFn: DashboardEntryRenderFnEnum.PRICE_PER_UNIT,
                    renderFn: DashboardEntryRenderFnEnum.PRICE_PER_UNIT,
                    allowEdit: true,
                },
                {
                    title: "total",
                    topRowColFn: DashboardEntryRenderFnEnum.TOTAL,
                    renderFn: DashboardEntryRenderFnEnum.TOTAL,
                },
            ],
            totalSection: {
                isVisible: true,
                isTaxVisible: true,
                isShippingVisible: true,
                isSubTotalsVisible: true,
                isGrandTotalVisible: true,
            },
        };
    };

    const getSearchFilterSelections = (): { name: boolean; sku: boolean; description: boolean; upc: boolean } => {
        const selections = {
            name: true,
            sku: true,
            description: true,
            upc: true,
        };

        if (supplierModel.settings?.screens?.dashboard_order_entry?.search_filters) {
            const filters = supplierModel.settings.screens.dashboard_order_entry.search_filters;

            if (!_.isNil(filters.name)) {
                selections.name = filters.name;
            }

            if (!_.isNil(filters.sku)) {
                selections.sku = filters.sku;
            }

            if (!_.isNil(filters.description)) {
                selections.description = filters.description;
            }

            if (!_.isNil(filters.upc)) {
                selections.upc = filters.upc;
            }
        }

        return selections;
    };

    const [disableAddBtn, setDisableAddBtn] = useState(true);
    const [addItemActive, setAddItemActive] = useState(false);
    const [clearTypeahead, setClearTypeahead] = useState(false);
    const [selectedCatalogItem, setSelectedCatalogItem] = useState<ICatalog_Item>();
    const [foundCatalogItems, setFoundCatalogItems] = useState<ICatalog_Item[]>([]);
    const [qty, setQty] = useState<number>();
    const [pricePerUnit, setPricePerUnit] = useState<number | string>("");
    const [manualPrice, setManualPrice] = useState<boolean>(false);
    const [description, setDescription] = useState<string>("");
    const [msrp, setMsrp] = useState<number | string>(0);
    const [rowTotal, setRowTotal] = useState<number | string>("");
    const [confirmDeleteElem, setConfirmDeleteElem] = useState("");
    const [currentDeleteIndex, setCurrentDeleteIndex] = useState<number | undefined>();
    const [searchFilterSelections, setSearchFilterSelections] = useState(getSearchFilterSelections());
    const [searchPhrase, setSearchPhrase] = useState("");
    const [selectedItemOptions, setSelectedItemOptions] = useState<IOrder_Item_Option[]>([]);

    // Required item options must have a value before the item can be added.
    const requiredItemOptionsComplete =
        !selectedCatalogItem || CatalogItemService.areRequiredItemOptionsSelected(selectedCatalogItem, selectedItemOptions).isComplete;

    useEffect(() => {
        findCatalogItems(searchPhrase);
    }, [searchPhrase]);

    const dashboardConfig = supplierModel.dashboard_entry_config || defaultConfig();

    useEffect(() => {
        console.log("props.catalog: ", props.catalog);

        const sockets: { endpoint: EndpointsEnum; fn: any }[] = [
            { endpoint: EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, fn: onGetCatalogItems },
            // { endpoint: EndpointsEnum.OrderOnCreateOrder, fn: onCreateOrder },
            // { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: onGetCatalogs },
        ];

        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const isItemSelectable = (item: ICatalog_Item) => {
        return true;
    };

    const toggleSearchFilter = (item: string) => {
        const _searchFilterSelections = { ...searchFilterSelections };

        // @ts-expect-error
        _searchFilterSelections[item] = !_searchFilterSelections[item];

        setSearchFilterSelections(_searchFilterSelections);
    };

    const findCatalogItems = (searchTerm: string) => {
        if (props.catalog && props.priceGroup) {
            const payload: ITypeaheadCatalogItemDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                catalogGuid: props.catalog.guid,
                priceGroupGuid: props.priceGroup.guid,
                name: searchTerm,
                limit: 100,
                onlyActive: true,
                excludeComponents: true,
                options: {
                    searchName: searchFilterSelections.name,
                    searchSku: searchFilterSelections.sku,
                    searchDescription: searchFilterSelections.description,
                    searchUpc: searchFilterSelections.upc,
                },
            };

            if (!userModel.isSupplierUser) {
                payload.vendorGuid = vendorModel.guid;
            }

            socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
        } else {
            const notification: INotification = {
                message: "account_requires_review_for_item_lookup",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            };
            uiContext.notifyFn(null, notification);
        }
    };

    const onGetCatalogItems = (data: IOnTypeaheadCatalogItemDTO) => {
        setFoundCatalogItems(data.catalog_items);
    };

    const selectCatalogItem = (item: ICatalog_Item) => {
        setSelectedCatalogItem(item);
        // console.log(item);

        const price = props.getPricingValue(item);

        if (supplierModel.guid !== SupplierGuidEnum.PANASONIC_CA) {
            setPricePerUnit(price);
        } else {
            setPricePerUnit(0);
            setManualPrice(true);
        }

        setMsrp(item.msrp || 0);
        setDescription(item.description || "");
    };

    const checkIfEnableAdd = () => {
        let _enableAdd = true;

        if (!selectedCatalogItem) {
            _enableAdd = false;
        }

        if (qty && qty <= 0) {
            _enableAdd = false;
        }

        setDisableAddBtn(!_enableAdd);
    };

    const handleQtyChange = (e: ChangeEvent<any>) => {
        let value = Number(e.target.value || 1);

        if (_.isNil(value) || _.isNaN(value)) {
            value = 1;
        }

        const precision = supplierModel?.qty_precision ?? 0;
        const multiplier = Math.pow(10, precision);
        value = Math.round(value * multiplier) / multiplier;

        const _rowTotal = value * Number(pricePerUnit);

        setQty(value);
        setRowTotal(_rowTotal);

        checkIfEnableAdd();
    };

    const handlePriceChange = (e: ChangeEvent<any>) => {
        let value = Number(e.target.value || 1);

        if (_.isNil(value)) {
            value = 1;
        }

        if (_.isNaN(value)) {
            value = 1;
        }

        const _rowTotal = value * Number(qty);

        setPricePerUnit(value);
        setRowTotal(_rowTotal);

        checkIfEnableAdd();
    };

    const handleMsrpChange = (e: ChangeEvent<any>) => {
        let value = Number(e.target.value || 0);

        if (_.isNil(value)) {
            value = 0;
        }

        if (_.isNaN(value)) {
            value = 0;
        }

        setMsrp(value);
    };

    const handleDescriptionChange = (e: ChangeEvent<any>) => {
        let value = e.target.value;

        if (_.isNil(value)) {
            value = "";
        }

        if (_.isNaN(value)) {
            value = "";
        }

        setDescription(value);
    };

    const clearSelectedCatalogItem = () => {
        setSelectedCatalogItem(undefined);
        setSelectedItemOptions([]);
        setClearTypeahead(false);
    };

    const addBtnColTop = () => {
        return (
            <td className={"col"}>
                <OwButton
                    title={"add"}
                    leftIconClass={"fas fa-plus"}
                    fn={addItem}
                    disableOnActive={true}
                    disabled={disableAddBtn || !requiredItemOptionsComplete}
                    active={addItemActive}
                    btnSizeClass={"btn-sm"}
                    className={"btn-primary no-wrap"}
                />
            </td>
        );
    };

    const createNewFn = (value?: string) => {
        if (props.catalog.Free_Entry_Catalog_Item) {
            setSelectedCatalogItem(props.catalog.Free_Entry_Catalog_Item);
            setFoundCatalogItems([]);
        }
    };

    const updateTypeaheadValue = (str: string) => {
        setSearchPhrase(str);
    };

    const itemLookupColTop = () => {
        return (
            <td className={"col-3"}>
                <Typeahead
                    isSelectableFn={isItemSelectable}
                    typeaheadApiFn={updateTypeaheadValue}
                    typeaheadItems={foundCatalogItems}
                    selectedItem={selectedCatalogItem}
                    selectedItemFn={selectCatalogItem}
                    titleProp={"name"}
                    subTitleProp={"sku"}
                    itemsRenderFn={(item: ICatalog_Item) => {
                        const description = item.description || "";

                        return (
                            <div>
                                <div>{item.sku}</div>
                                <div className={"text-muted text-small"}>
                                    {description.substring(0, 100)}
                                    {description.length > 100 ? "..." : ""}
                                </div>
                            </div>
                        );
                    }}
                    scrollableList={true}
                    clearTypeaheadCallback={clearSelectedCatalogItem}
                    clearTypeahead={clearTypeahead}
                    stickyCreateNewToTop={true}
                    showCreateNew={!!props.catalog?.Free_Entry_Catalog_Item}
                    createNewFn={props.catalog?.Free_Entry_Catalog_Item ? createNewFn : undefined}
                    createNewText={"free_item_entry"}
                    maxResults={100}
                    sideFilter={true}
                    sideFilterItems={[
                        {
                            name: "name",
                            children: (
                                <OwCheckbox
                                    label={"name"}
                                    name={"name"}
                                    checked={searchFilterSelections.name}
                                    fn={() => toggleSearchFilter("name")}
                                />
                            ),
                        },
                        {
                            name: "sku",
                            children: (
                                <OwCheckbox
                                    label={"sku"}
                                    name={"sku"}
                                    checked={searchFilterSelections.sku}
                                    fn={() => toggleSearchFilter("sku")}
                                />
                            ),
                        },
                        {
                            name: "description",
                            children: (
                                <OwCheckbox
                                    label={"description"}
                                    checked={searchFilterSelections.description}
                                    name={"description"}
                                    fn={() => toggleSearchFilter("description")}
                                />
                            ),
                        },
                    ]}
                />
                {hasDescriptionCol ? null : renderItemOptions()}
            </td>
        );
    };

    const selectedItemOptionsFn = (options: any) => {
        setSelectedItemOptions(options);
    };

    // Item options live in the description column. A supplier's dashboard layout can omit that
    // column, so the lookup column shows them instead; otherwise required options could never be
    // answered and Add would stay disabled.
    const hasDescriptionCol = !!dashboardConfig.columns?.some((col) => col.topRowColFn === DashboardEntryRenderFnEnum.DESCRIPTION);

    // Keyed by catalog item so switching items remounts the options and drops the previous item's answers.
    const renderItemOptions = () =>
        selectedCatalogItem?.Options ? (
            <div className={"mt-2 mb-2"}>
                <OrderItemOptions
                    key={selectedCatalogItem.guid ?? selectedCatalogItem.id}
                    catalogItem={selectedCatalogItem}
                    selectedItemOptionsFn={selectedItemOptionsFn}
                />
            </div>
        ) : null;

    const descriptionColTop = (col: IDashboardEntryCol) => {
        if (selectedCatalogItem) {
            return (
                <td className={""}>
                    {col.allowEdit ? (
                        <div>
                            <OwFnInput fn={handleDescriptionChange} name={"description"} value={description} />
                        </div>
                    ) : (
                        <p className={"descriptionTd"}>{selectedCatalogItem ? selectedCatalogItem.description : ""}</p>
                    )}
                    {renderItemOptions()}
                </td>
            );
        } else {
            return <td></td>;
        }
    };

    const qtyColTop = () => {
        const step = OrderEntryService.getQtyStepValue(supplierModel?.qty_precision, selectedCatalogItem?.unit_incr_qty);
        return (
            <td className={"col-1"}>
                {selectedCatalogItem ? <OwFnInput fn={handleQtyChange} name={"qty"} value={qty} type={"number"} step={step} /> : null}
            </td>
        );
    };

    const pricePerUnitColTop = () => {
        return (
            <td className={"col-2"}>
                {selectedCatalogItem ? (
                    supplierModel.allow_manual_pricing ? (
                        <OwFnInput name={"pricePerUnit"} fn={handlePriceChange} value={pricePerUnit} />
                    ) : (
                        <NumericFormat
                            value={pricePerUnit}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                    )
                ) : (
                    ""
                )}
            </td>
        );
    };

    const msrpColTop = (col: IDashboardEntryCol) => {
        return (
            <td className={"col-1"}>
                {selectedCatalogItem ? (
                    col.allowEdit ? (
                        <OwFnInput name={"msrp"} fn={handleMsrpChange} value={msrp} />
                    ) : (
                        <NumericFormat
                            value={selectedCatalogItem.msrp || 0}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                    )
                ) : (
                    ""
                )}
            </td>
        );
    };

    const totalColTop = () => {
        return (
            <td className={"col-1 text-end"}>
                {selectedCatalogItem ? (
                    <NumericFormat
                        value={rowTotal}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                ) : (
                    ""
                )}
            </td>
        );
    };

    const showConfirmDelete = (index: number) => {
        setCurrentDeleteIndex(index);
        setConfirmDeleteElem(`item-row-${index}`);
    };

    const renderItemNoCol = (index: number, hasError?: any) => {
        return (
            <td>
                <>
                    <OwDeleteEditActions
                        isEditMode={false}
                        onTrashClickFn={() => {
                            showConfirmDelete(index);
                        }}
                        onEditClickFn={() => {}}
                        hideEdit={true}
                        className={"d-inline-flex me-2"}
                    />
                </>
                {index + 1}
                <>{hasError ? <i className={"text-danger fas fa-exclamation-triangle ms-2"} /> : null}</>
            </td>
        );
    };

    const renderItemName = (item: IDashboardEntryItemUI, hasError: any) => {
        return (
            <td>
                <div>{item.Catalog_Item.name}</div>
                {hasError ? <div>{!hasError.active ? <OwLabel className={"text-danger"} title={"item_inactive"} /> : null}</div> : null}
            </td>
        );
    };

    const renderSkuCol = (item: IDashboardEntryItemUI) => {
        return (
            <td>
                <div>{item.Catalog_Item.sku || item.Catalog_Item.name}</div>
            </td>
        );
    };

    const renderDescriptionCol = (item: IDashboardEntryItemUI) => {
        return (
            <td>
                <p className={"descriptionTd"}>{item.description || item.Catalog_Item.description}</p>
                {item.Item_Options && (
                    <div className={"mt-2 mb-2"}>
                        {item.Item_Options?.map((itemOption) => {
                            let optionName = itemOption.Item_Option?.name;

                            if (!optionName) {
                                const option = item.Catalog_Item.Options?.find(
                                    (option) => option.item_option_id === itemOption.item_option_id
                                );

                                if (option) {
                                    optionName = option.Item_Option?.name;
                                }
                            }

                            return (
                                <div key={itemOption.item_option_id}>
                                    <b>{optionName}:</b> {startCase(itemOption.value)}
                                </div>
                            );
                        })}
                    </div>
                )}
            </td>
        );
    };

    const renderQtyCol = (item: IDashboardEntryItemUI, hasError: any) => {
        return (
            <td>
                <DashboardItemEntryQty item={item} updateItem={props.updateItem} />
                {hasError ? (
                    <div className={"text-danger"}>
                        {!_.isNil(hasError.inventoryAvailable) ? (
                            <>
                                <OwLabel title={"inventory"} className={"me-2"} postText={":"} />
                                {hasError.inventoryAvailable}
                            </>
                        ) : null}
                    </div>
                ) : null}
            </td>
        );
    };

    const renderPricePerUnitCol = (item: IDashboardEntryItemUI, price: number) => {
        return (
            <td>
                {supplierModel.allow_manual_pricing ? (
                    <DashboardItemEntryPricePerUnit item={item} updateItem={props.updateItem} getPricingValue={props.getPricingValue} />
                ) : (
                    price
                )}
            </td>
        );
    };

    const renderMsrpCol = (item: IDashboardEntryItemUI) => {
        return (
            <td>
                <NumericFormat
                    value={item.msrp || item.Catalog_Item.msrp || 0}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            </td>
        );
    };

    const renderRowTotalCol = (item: IDashboardEntryItemUI, _rowTotal: number) => {
        return (
            <td className={"text-end"}>
                <NumericFormat
                    value={_rowTotal}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            </td>
        );
    };

    const handleCancelDelete = () => {
        setCurrentDeleteIndex(undefined);
        setConfirmDeleteElem("");
    };

    const handleConfirmDelete = () => {
        // remove the current index from the item list.
        if (currentDeleteIndex !== undefined) {
            props.removeItem(props.dashboardEntryItems[currentDeleteIndex]);
            setCurrentDeleteIndex(undefined);
            setConfirmDeleteElem("");
        }
    };

    return (
        <div className={"DashboardItemEntryPanel row"}>
            <div className="col-12 position-relative">
                <ConfirmDeleteOverlayFn
                    targetElem={confirmDeleteElem}
                    handleConfirm={handleConfirmDelete}
                    handleCancel={handleCancelDelete}
                    leftAdjustment={-12}
                    skipMainView={true}
                    nestedParentElem={"dashboard-item-entry"}
                />

                <table className={"table table-striped " + (!isMainViewLight ? "table-dark" : "")} id={"dashboard-item-entry"}>
                    <thead>
                        <tr>
                            {dashboardConfig.columns?.map((col, index) => {
                                return (
                                    <th key={index} className={col.titleClassName}>
                                        <OwLabel title={col.title} />
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {dashboardConfig.columns?.map((col) => {
                                switch (col.topRowColFn) {
                                    case DashboardEntryRenderFnEnum.ADD_BTN:
                                        return addBtnColTop();
                                    case DashboardEntryRenderFnEnum.ITEM_LOOKUP:
                                        return itemLookupColTop();
                                    case DashboardEntryRenderFnEnum.DESCRIPTION:
                                        return descriptionColTop(col);
                                    case DashboardEntryRenderFnEnum.QTY:
                                        return qtyColTop();
                                    case DashboardEntryRenderFnEnum.PRICE_PER_UNIT:
                                        return pricePerUnitColTop();
                                    case DashboardEntryRenderFnEnum.TOTAL:
                                        return totalColTop();
                                    case DashboardEntryRenderFnEnum.MSRP:
                                        return msrpColTop(col);
                                    default:
                                        return <td></td>;
                                }
                            })}
                        </tr>
                        {props.dashboardEntryItems.map((item, index) => {
                            const price = !_.isNil(item.manual_price) ? item.manual_price : props.getPricingValue(item.Catalog_Item);
                            const _rowTotal = price * Number(item.qty);

                            const hasError = props.submitErrors?.errors?.find(
                                (error) => error.name === item.Catalog_Item.name || error.sku === item.Catalog_Item.sku
                            );

                            return (
                                <tr id={`item-row-${index}`} key={index}>
                                    {dashboardConfig.columns?.map((col) => {
                                        switch (col.renderFn) {
                                            case DashboardEntryRenderFnEnum.ITEM_NO:
                                                return renderItemNoCol(index, hasError);
                                            case DashboardEntryRenderFnEnum.ITEM_LOOKUP:
                                                return renderItemName(item, hasError);
                                            case DashboardEntryRenderFnEnum.DESCRIPTION:
                                                return renderDescriptionCol(item);
                                            case DashboardEntryRenderFnEnum.QTY:
                                                return renderQtyCol(item, hasError);
                                            case DashboardEntryRenderFnEnum.PRICE_PER_UNIT:
                                                return renderPricePerUnitCol(item, price);
                                            case DashboardEntryRenderFnEnum.TOTAL:
                                                return renderRowTotalCol(item, _rowTotal);
                                            case DashboardEntryRenderFnEnum.MSRP:
                                                return renderMsrpCol(item);
                                            case DashboardEntryRenderFnEnum.SKU:
                                                return renderSkuCol(item);
                                            default:
                                                return <td></td>;
                                        }
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
